import React from "react";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";

const CButton3 = ({
  cText,
  cSrc,
  cTooltipText,
  cDisabled,
  cOnClick,
  cLink,
  CFullWidth,
}) => {
  const { t } = useTranslation();

  const handleClick = () => {
    if (cOnClick !== undefined) {
      cOnClick();
    }
  };
  return (
    <Tooltip title={t(cTooltipText)} arrow>
      <span>
        {(cText !== undefined && (
          <Button
            aria-label={cTooltipText}
            disabled={cDisabled}
            onClick={handleClick}
            color="primary"
            variant="contained"
            sx={{
              fontSize: { xs: "0.75rem", sm: "0.875rem" },
              padding: { xs: "0.5rem", sm: "0.5rem" },
              minHeight: { xs: "40px", sm: "44px" },
              minWidth: { xs: "40px", sm: "44px" },
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "6px",
              "& .MuiSvgIcon-root": {
                fontSize: { xs: "1.2rem", sm: "1.5rem" },
              },
            }}
            fullWidth={CFullWidth}
          >
            {cText}
          </Button>
        )) ||
          (cSrc !== undefined && (
            <Button
              aria-label={cTooltipText}
              disabled={cDisabled}
              onClick={handleClick}
              color="primary"
              variant="contained"
              sx={{
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                padding: { xs: "0.5rem", sm: "0.5rem" },
                minHeight: { xs: "40px", sm: "44px" },
                minWidth: { xs: "40px", sm: "44px" },
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "6px",
                "& .MuiSvgIcon-root": {
                  fontSize: { xs: "1.2rem", sm: "1.5rem" },
                },
              }}
            >
              {cSrc}
            </Button>
          ))}
      </span>
    </Tooltip>
  );
};

export default CButton3;
